import React, { useEffect, useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import styled from 'styled-components';
import Loader from '@sportnet/ui/Loader';
import Api from '../../Api';
import Layout from '../../components/Layout';
import { __ } from '../../utilities';

const CenteredWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 50vh;
  text-align: center;
`;

const ErrorMessage = styled.div`
  color: #dc3545;
  margin-top: 16px;
`;

/**
 * Redirect component that takes a PPO ID (e.g., issf_club_13516),
 * fetches the organization_id from the API, and redirects to the organization profile page.
 */
const PpoRedirect = () => {
  const { appspace, ppoId } = useParams();
  const history = useHistory();
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPpoAndRedirect = async () => {
      try {
        const ppo = await Api.organizationPPOProfile(ppoId);
        if (ppo && ppo.organization_id && ppo._id) {
          history.replace(
            `/admin/${appspace}/organizations/${ppo.organization_id}/profiles/${ppo._id}/profile`,
          );
        } else {
          setError(__('Nepodarilo sa nájsť organizáciu pre zadané PPO ID.'));
        }
      } catch (e) {
        if (e.status === 404) {
          setError(__('PPO s daným ID nebolo nájdené.'));
        } else {
          setError(
            e.details?.userinfo ||
              __('Pri získavaní informácií o PPO nastala chyba.'),
          );
        }
      }
    };

    fetchPpoAndRedirect();
  }, [appspace, ppoId, history]);

  return (
    <Layout>
      <CenteredWrapper>
        {error ? (
          <ErrorMessage>{error}</ErrorMessage>
        ) : (
          <>
            <Loader size="xl" />
            <div style={{ marginTop: 16 }}>
              {__('Načítavam organizáciu...')}
            </div>
          </>
        )}
      </CenteredWrapper>
    </Layout>
  );
};

export default PpoRedirect;
